import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { kotaApi, KotaListParams } from '@/api/kota';
import { Kota } from '@/types';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useKotaList = (params: KotaListParams = {}) =>
  useQuery({
    queryKey: ['kota', params],
    queryFn: () => kotaApi.getAll(params),
  });

export const useCreateKota = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: Partial<Kota>) => kotaApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['kota'] });
      feedback.success('Kota berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat kota', error);
    },
  });
};

export const useUpdateKota = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Kota> }) => kotaApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['kota'] });
      feedback.success('Kota berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui kota', error);
    },
  });
};

export const useDeleteKota = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (id: number) => kotaApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['kota'] });
      feedback.success('Kota berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus kota', error);
    },
  });
};
